module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_no-inverter-no-pv.636205f3.svg";